/* The activity view. Tokens only (ADR-0007) and nothing below 12px (`--t-min`). */

.stack {
  grid-column: 1 / -1;
  display: grid;
  gap: var(--gap);
  min-width: 0;
}

.whoCan {
  margin: 0;
  padding: 10px 12px;
  border: 1px solid var(--line);
  border-radius: 8px;
  background: var(--panel-2);
  font-size: var(--t-dense);
  color: var(--ink-2);
  line-height: 1.5;
  max-width: 68ch;
}

.whoCan strong {
  display: block;
  color: var(--ink);
  margin-bottom: 4px;
}

.note {
  margin: 8px 0 0;
  font-size: var(--t-min);
  color: var(--muted);
  line-height: 1.5;
  max-width: 80ch;
}

.filters {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 10px var(--gap);
  align-items: end;
}

@media (width <= 760px) {
  .filters {
    grid-template-columns: minmax(0, 1fr);
  }
}

.field {
  display: grid;
  gap: 4px;
  min-width: 0;
  font-size: var(--t-min);
  color: var(--muted);
}

.field select,
.field input {
  min-width: 0;
  padding: 7px 8px;
  border: 1px solid var(--line);
  border-radius: 6px;
  background: var(--panel);
  color: var(--ink);
  font: inherit;
  font-size: var(--t-dense);
}

.field input[aria-invalid="true"] {
  border-color: var(--crit);
}

.actions {
  grid-column: 1 / -1;
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}

.apply,
.clear,
.chip {
  padding: 6px 10px;
  border: 1px solid var(--line);
  border-radius: 6px;
  background: var(--panel-2);
  color: var(--ink);
  font: inherit;
  font-size: var(--t-min);
  cursor: pointer;
}

.apply {
  background: var(--accent);
  border-color: var(--accent);
  color: var(--on-fill);
}

.apply:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.list {
  list-style: none;
  margin: 0;
  padding: 0;
  display: grid;
  gap: 0;
}

.row {
  display: grid;
  gap: 4px;
  padding: 10px 0;
  border-bottom: 1px solid var(--line);
  min-width: 0;
}

.row:last-child {
  border-bottom: 0;
}

.sentence {
  margin: 0;
  font-size: var(--t-dense);
  color: var(--ink);
  overflow-wrap: anywhere;
}

.meta {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 6px 12px;
  margin: 0;
  font-size: var(--t-min);
  color: var(--muted);
}

.seq {
  font-variant-numeric: lining-nums tabular-nums;
  color: var(--accent);
}

.when {
  font-variant-numeric: lining-nums tabular-nums;
}

.actor {
  min-width: 0;
  overflow-wrap: anywhere;
}

.pager {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 8px;
  margin-top: 12px;
}

/* The two id boxes in the filter line: compact, on the one row. */
.idForm {
  display: inline-flex;
  flex-wrap: nowrap;
  align-items: center;
  gap: 6px;
}

.idForm input {
  width: 9rem;
  min-height: var(--h-ctl);
  padding: 0 8px;
  border: 1px solid var(--line-2);
  border-radius: var(--radius-ctl);
  background: var(--panel);
  color: var(--ink);
  font-size: var(--t-dense);
}

.hint {
  font-size: var(--t-dense);
  color: var(--muted);
}

.rowButtons {
  display: inline-flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 8px;
}

/* The entry number is a link to the entry's own page: a 24px target (WCAG 2.5.8), in the link colour. */
.seqLink {
  display: inline-flex;
  align-items: center;
  min-width: var(--target-min);
  min-height: var(--target-min);
  color: var(--accent);
  text-decoration: none;
}

.seqLink:hover,
.seqLink:focus-visible {
  text-decoration: underline;
  text-underline-offset: 2px;
}
